export const removeCategoryButtonLabel = "qyF1nb";
export const searchCategoryButtonLabel = "Qlu7b";
export default {removeCategoryButtonLabel,searchCategoryButtonLabel};